import React from "react";
import './header.css';

export function Header(props) {
  return (
    <header class="text-center relative">
      <div class="header-bg z-[-1]"></div>
      <h1>
          <img alt="Intel Innovation, September 27-28, 2022, San Jose" class='m-auto' src="https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/REGISTRATION_Logo_Only_1657190947766001CufP.png"/>
      </h1>
    </header>
  );
}

